import styles from './DesktopWrapper.module.scss';

import React, { PropsWithChildren } from 'react';

export const DesktopWrapper: React.FC<PropsWithChildren<unknown>> = (props) => {
  return <div className={styles['desktop-wrapper']}>{props.children}</div>;
};
